<template>
  <div class="table-container">
    <b-overlay center :show="isLoading" rounded="sm">
      <div v-if="!isLoading">
        <div v-if="ok">
          <validation-observer
            ref="observer"
            v-slot="{ invalid, handleSubmit }"
          >
            <b-form @submit.prevent="" autocomplete="off">
              <div class="form-card-wrapper mt-3">
                <b-card header-tag="header">
                  <template #header>
                    <b>Credenziali eMessage</b>
                  </template>
                  <b-card-text>
                    <b-row>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].attribute_EMUSR_value.label"
                          vid="attribute_EMUSR_value"
                          :label="beForm[rep].attribute_EMUSR_value.label"
                          v-model="form[rep].attribute_EMUSR_value"
                          :rules="{ required: true }"
                          placeholder="Inserisci lo username"
                          autocomplete="one-time-code"
                        />
                      </div>
                      <div class="form-group">
                        <base-input
                          :name="beForm[rep].attribute_EMPWD_value.label"
                          vid="attribute_EMPWD_value"
                          :label="beForm[rep].attribute_EMPWD_value.label"
                          type="password"
                          v-model="form[rep].attribute_EMPWD_value"
                          :rules="{ required: true }"
                          placeholder="Inserisci la password"
                          autocomplete="one-time-code"
                        />
                      </div>
                    </b-row>
                  </b-card-text>
                </b-card>
              </div>
              <div class="form-actions form-actions--sticky">
                <div class="inner-wrapper">
                  <div>
      <span
        :title="`${
          invalid
            ? 'Compila correttamente i campi per poter salvare'
            : 'Invia il form'
        }`"
      >
        <b-button
          @click="handleSubmit(onSubmit)"
          type="button"
          :disabled="invalid"
          variant="lisaweb"
          size="sm"
          :title="`${
            invalid
              ? 'Compila correttamente i campi per poter salvare'
              : 'Invia il form'
          }`"
        >
          Salva
        </b-button>
      </span>
                    <b-button
                      @click="resetForm()"
                      class="btn--transparent btn-reset"
                      type="button"
                      title="Pulisci tutti i campi e compila il form nuovamente"
                    >Reset
                    </b-button
                    >
                  </div>
                  <div>
                    <b-button
                      @click="$router.back()"
                      class="btn--transparent"
                      type="button"
                      title="Torna alla pagina precedente"
                    >
                      <b-icon-chevron-double-left
                        font-scale="0.9"
                      ></b-icon-chevron-double-left
                      >
                      Torna indietro
                    </b-button
                    >
                  </div>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </div>
        <div v-else>
          {{ errorMessage }}
        </div>
      </div>
      <template #overlay>
        <div class="text-center">
          <div class="custom-loader"></div>
          <p class="loading-text">Operazione in corso...</p>
        </div>
      </template>
    </b-overlay>
  </div>
</template>

<script>
import FormMixin from "@/mixins/FormMixin";
import BaseInput from "@/components/form/BaseInput";
import ShortcutMixin from "@/mixins/ShortcutMixin";

export default {
  mixins: [FormMixin, ShortcutMixin],
  data() {
    return {
      repository: "agency_setup",
      id: this.$store.state.auth.settings.id,
      form: {
        agency_setup: {
          attribute_EMUSR_value: null,
          attribute_EMPWD_value: null,
        },
      },
    };
  },
  components: {
    BaseInput,
  },
  methods: {
    onSubmit() {
      this.isLoading = true;

      // Update agency_setup form
      this.update(this.rep, this.id)
        .then(() => {
          this.$showSnackbar({
            preset: "success",
            text: `Azione completata: Dati di agenzia aggiornati`,
          });
          // this.shortcut("agency_setups.index", null, null);
          this.isLoading = false;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({preset: "error", text: errMsg});
          this.isLoading = false;
        });

      // Update EMUSR
      if (this.form[this.rep].attribute_EMUSR_value)
        this.$store.state.auth.settings.attribute_EMUSR_value =
          this.form[this.rep].attribute_EMUSR_value;

      // Update EMPWD
      if (this.form[this.rep].attribute_EMPWD_value)
        this.$store.state.auth.settings.attribute_EMPWD_value =
          this.form[this.rep].attribute_EMPWD_value;
    },
    fetch() {
      this.isLoading = true;

      // Fetch edit agency_setup form
      this.fetchEditForm(this.rep, this.id)
        .then(() => {
          this.initMandatoryFields("agency_setup");
          this.isLoading = false;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({preset: "error", text: errMsg});
          this.isLoading = false;
        });
    },
  },
  created() {
    this.fetch();
  },
  computed: {
    rep() {
      return this.repository;
    },
    computedEmessageLink() {
      return `https://wichee.emessage.it/SignUpWichee.aspx?PIN=${this.$store.state.auth.settings.code}`;
    },
  },
};
</script>
